import { Modal, ModalBody, ModalProps, Row } from 'react-bootstrap';
import SuccessImage from '../../../assets/letter-success.svg';
import Button from '../../../components/Button/Button';
import ModalHeader from '../../../components/ModalHeader';
import useMobile from '../../../hooks/useMobileHook';

export type customSuccessVerificationModalProps = ModalProps &
  React.PropsWithChildren<{
    showSuccessVerificationModal: boolean;
    handleCloseSuccessVerificationModal: () => void;
  }>;

const SuccessVerificationModal = ({
  showSuccessVerificationModal,
  handleCloseSuccessVerificationModal,
}: customSuccessVerificationModalProps) => {
  const isMobile = useMobile();

  return (
    <Modal
      show={showSuccessVerificationModal}
      onHide={handleCloseSuccessVerificationModal}
      dialogClassName="modal-xl custom-success-modal"
      fullscreen={isMobile}
    >
      <ModalHeader className="justify-content-center" closeButton></ModalHeader>
      <ModalBody className="pt-0 pb-0">
        <Row className="m-0 pb-12 text-center">
          <h4>Success!</h4>
        </Row>
        <Row className="m-0 pb-12 justify-content-center">
          <img className="img-container" src={SuccessImage} alt="success-img" />
        </Row>
        <Row className="m-0">
          <div className="d-flex justify-content-center text-sub1 fw-light">
            <span>
              Your Verification letter will be sent out within 3-4 business
              days.
            </span>
          </div>
        </Row>
      </ModalBody>
      <Modal.Footer>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseSuccessVerificationModal}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessVerificationModal;
